import React from "react";
import { Link } from "react-router-dom";
const VivaWood = () => {
  return (
       <div>
                {/* Spinner Start */}
               
                {/* Spinner End */}

            
                <div class="container">
            <h2 class="title">Viva Wood Series</h2>
            <div class="grid">
                <div class="grid-item">
                <Link to="/product-details">
                    <img src="/assets/img/17065922655282.jpg" alt="Woodland Symphony"/>
                    </Link>
                    <p>Appalachian Heritage</p>
                </div>
                <div class="grid-item">
                <Link to="/product-details">
                    <img src="/assets/img/17074108982365.jpg" alt="Classic Scarborough"/>
                    </Link>
                    <p>WHISPERING ZEPHYR</p>
                </div>
              
                </div>
                </div>
            
        
            <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top">
                <i className="bi bi-arrow-up"></i>
              </a>
          
          
                {/* Optional: Add any other content or components here */}
            
                <style>
                  {`
                    /* Add your custom CSS here */
                    .service-item-top {
                      transition: transform 0.3s ease-in-out;
                    }
            
                    .service-item-top:hover {
                      transform: scale(1.05);
                    }
                 .title {
        font-size: 24px;
        font-weight: bold;
        text-align: left;
        margin-bottom: 20px;
    }
    .grid-item img{
    display: block;
      height: 300px;
      overflow: hidden;
      width: 100%;}
    .grid {
        display: flex;
        flex-wrap: wrap;
      
        gap: 15px;
    }
    .container{margin-top:50px}
    .grid-item {
        width: calc(33.333% - 10px);
        background: white;
        border-radius: 5px;
        overflow: hidden;
        text-align: center;
    }
    
    
    
    .grid-item p {
        margin: 10px 0;
        font-weight: bold;
        font-size: 14px;
    }
    
    /* Responsive Styles */
    @media (max-width: 900px) {
        .grid-item {
            width: calc(50% - 10px);
        }
    }
    
    @media (max-width: 600px) {
        .grid-item {
            width: 100%;
        }
    }
                    /* Add any additional styling you want */
                  `}
                </style>
              </div>
  );
};

export default VivaWood;
